import {
  Button,
  HeaderSection,
  Heading,
  Icon,
  Popover,
  Text
} from '@lmc/ui-kit'
import { ProTag } from 'components/ProTag'
import type { FC } from 'react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  handleToggleModal: () => void
  allowCreateEditTemplates: boolean
  preferredPeopleNominative?: string
}

const StyledHeading = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
`

const StyledLink = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
  margin-left: 5px;
`

const StyledLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 257px;
`

const StyledAnchor = styled.a`
  color: black;
  text-decoration: underline;
`

const StyledFlexContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SkillNeedTemplateHeaderSection: FC<Props> = ({
  handleToggleModal,
  allowCreateEditTemplates,
  preferredPeopleNominative
}) => {
  const { t } = useTranslation()

  const renderButton = (
    <div>
      <Button
        disabled={!allowCreateEditTemplates}
        icon={<Icon name="PlusOutlined" />}
        variant="primary"
        onClick={handleToggleModal}
        style={{ fontWeight: 400 }}
      >
        {t(`skillsAndNeeds.addNewSkill`)}
      </Button>
    </div>
  )

  return (
    <StyledHeaderWrapper>
      <HeaderSection
        title={
          <StyledFlexContainer>
            {t('skillsAndNeeds.skillTemplatesTitle')}
            <ProTag />
          </StyledFlexContainer>
        }
        subtitle={t('skillsAndNeeds.skillTemplatesSubtitle', {
          serviceUsers: preferredPeopleNominative?.toLowerCase()
        })}
        subtitleStyle={{ marginTop: 8 }}
        rightChildren={
          !allowCreateEditTemplates ? (
            <Popover
              placement="bottomRight"
              content={
                <StyledLinkWrapper>
                  <Text level={2}>{t('skillsAndNeeds.tableReadOnly')}</Text>
                  <div>
                    <StyledHeading level={5}>
                      {t('skillsAndNeeds.tableReadOnlyDescription')}
                    </StyledHeading>
                    <StyledLink level={5}>
                      <StyledAnchor
                        href="https://support.logmycare.co.uk/en/articles/6987442-how-to-set-up-skills-for-your-service"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('skillsAndNeeds.tableReadOnlyLink')}
                      </StyledAnchor>
                    </StyledLink>
                  </div>
                </StyledLinkWrapper>
              }
            >
              {renderButton}
            </Popover>
          ) : (
            renderButton
          )
        }
      />
    </StyledHeaderWrapper>
  )
}

export default SkillNeedTemplateHeaderSection

const StyledHeaderWrapper = styled.div`
  margin-bottom: 10px;

  [data-testid="header-section"] > .ant-row > div {
    flex-wrap: nowrap !important;
    padding: 20px 28px !important;
  }

  [data-testid="header-section-right-children"] {
    margin-left: 40px;
    flex-shrink: 0;
  }

  [data-testid="header-section-title-container"] {
    min-width: 0;
  }

  [data-testid="header-section-subtitle"] {
    white-space: normal;
    word-break: break-word;
  }
`
